<template>
  <div class="bg-white-900 mb-14 mt-2">
    <div class="container mx-auto">
      <h1 class="sr-only">
        Catalog, popular publishers and list of all books here
      </h1>
      <div class="mb-16 flex space-x-3">
        <new-catalogs class="flex-grow" />
        <popular-publishers class="min-w-500 max-w-500" />
      </div>
      <actions-bar
        select-type="books"
        title="All Books"
        title-class="text-4xl"
        placeholder="Search by name, author, ISBN"
      />

      <list-books class="mb-13" />
      <recently-catalogs />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NewCatalogs from "@/components/sliders/NewCatalogs.vue";
import RecentlyCatalogs from "@/components/sliders/RecentlyCatalogs.vue";
import PopularPublishers from "@/components/asides/PopularPublishers.vue";
import TabBooks from "@/components/tabs/Books.vue";

export default {
  name: "Home",
  components: {
    "new-catalogs": NewCatalogs,
    "popular-publishers": PopularPublishers,
    "recently-catalogs": RecentlyCatalogs,
    "list-books": TabBooks,
    "actions-bar": () => import("@/components/base/ActionsBar.vue"),
  },
};
</script>
